<template>
    <!-- Zaslepka kafla systemu - trzyma uklad siatki, zanim przyjda dane ze statusami. -->
    <div class="tile-skeleton">
        <div class="tile-skeleton__accent"></div>
        <div class="tile-skeleton__body">
            <div class="tile-skeleton__line tile-skeleton__line--title"></div>
            <div class="tile-skeleton__columns">
                <div class="tile-skeleton__column">
                    <div class="tile-skeleton__line tile-skeleton__line--label"></div>
                    <div class="tile-skeleton__line tile-skeleton__line--value"></div>
                    <div class="tile-skeleton__line tile-skeleton__line--label"></div>
                    <div class="tile-skeleton__line tile-skeleton__line--value"></div>
                </div>
                <div class="tile-skeleton__column tile-skeleton__column--narrow">
                    <div class="tile-skeleton__line tile-skeleton__line--label"></div>
                    <div class="tile-skeleton__line tile-skeleton__line--value"></div>
                    <div class="tile-skeleton__line tile-skeleton__line--label"></div>
                    <div class="tile-skeleton__line tile-skeleton__line--value"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardTileSkeleton'
}
</script>

<style scoped>
.tile-skeleton {
    display: flex;
    min-height: 118px;
    overflow: hidden;
    border-radius: 6px;
    background: var(--surface);
    box-shadow: var(--dash-shadow);
}

.tile-skeleton__accent {
    width: 7px;
    flex: 0 0 7px;
    background: var(--skeleton-accent);
}

.tile-skeleton__body {
    flex: 1;
    min-width: 0;
    padding: 12px 16px 14px 18px;
}

.tile-skeleton__columns {
    display: flex;
    gap: 16px;
    margin-top: 12px;
}

.tile-skeleton__column {
    flex: 1;
    min-width: 0;
}

.tile-skeleton__column--narrow {
    flex: 0 0 90px;
}

.tile-skeleton__line {
    border-radius: 4px;
    background: linear-gradient(90deg, var(--skeleton) 25%, var(--skeleton-shine) 37%, var(--skeleton) 63%);
    background-size: 400% 100%;
    animation: tile-skeleton-loading 1.4s ease infinite;
}

.tile-skeleton__line--title {
    height: 20px;
    width: 65%;
}

.tile-skeleton__line--label {
    height: 8px;
    width: 45%;
    margin-bottom: 5px;
}

.tile-skeleton__line--value {
    height: 12px;
    width: 75%;
    margin-bottom: 12px;
}

.tile-skeleton__column--narrow .tile-skeleton__line--label,
.tile-skeleton__column--narrow .tile-skeleton__line--value {
    margin-left: auto;
}

@keyframes tile-skeleton-loading {
    0% { background-position: 100% 50%; }
    100% { background-position: 0 50%; }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashboardTileSkeleton.vue